/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetTransportationOptions
 */
export interface ResponseGetTransportationOptions {
    /**
     * 
     * @type {string}
     * @memberof ResponseGetTransportationOptions
     */
    alphaCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetTransportationOptions
     */
    displayOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetTransportationOptions
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetTransportationOptions
     */
    name?: string;
}

/**
 * Check if a given object implements the ResponseGetTransportationOptions interface.
 */
export function instanceOfResponseGetTransportationOptions(value: object): value is ResponseGetTransportationOptions {
    return true;
}

export function ResponseGetTransportationOptionsFromJSON(json: any): ResponseGetTransportationOptions {
    return ResponseGetTransportationOptionsFromJSONTyped(json, false);
}

export function ResponseGetTransportationOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetTransportationOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'alphaCode': json['alpha_code'] == null ? undefined : json['alpha_code'],
        'displayOrder': json['display_order'] == null ? undefined : json['display_order'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ResponseGetTransportationOptionsToJSON(json: any): ResponseGetTransportationOptions {
    return ResponseGetTransportationOptionsToJSONTyped(json, false);
}

export function ResponseGetTransportationOptionsToJSONTyped(value?: ResponseGetTransportationOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alpha_code': value['alphaCode'],
        'display_order': value['displayOrder'],
        'id': value['id'],
        'name': value['name'],
    };
}

